import React from "react";
import {
    Link
} from "react-router-dom";

import Helmet from "../../components/Helmet";
import CallToAction from "../../components/CallToAction";
import MidCallToAction from "../../components/MidCallToAction";
import VerticalCard from "../../components/VerticalCard";
import NavbarSettings from "../../components/navbar/NavbarSettings";
import SubPageBanner from "../../components/SubPageBanner";

import banner from "../../img/solar-banner.jpg";
import solaredgeCIBattery from "../../img/battery/solaredge-ci-batterij.png";

function SolarEdgeCIBatterij() {
    return (
        <React.Fragment>
            <Helmet
                title="SolarEdge C&I Batterij"
                description="Ontdek de krachtige SolarEdge C&I batterij bij Smith Solar. Met 50 kW laadvermogen, 102,4 kWh capaciteit en integratie met SolarEdge Monitoring."
            />

            <NavbarSettings>
                <SubPageBanner
                    title="SolarEdge C&I Batterij"
                    image={banner}
                    imgAlt="Foto van zonnepanelen"
                />
            </NavbarSettings>

            <div className="container-orange-background">
                <div className="container">
                    <div className="image-text-container">
                        <div className="text-container">
                            <h2 className="title">De SolarEdge C&I batterij</h2>
                            <div className="text">De SolarEdge C&I batterij biedt bedrijven een innovatieve oplossing voor energieopslag, ontworpen voor zowel binnen- als buitengebruik.
                                Deze Commercial Storage System (CSS) batterij is ideaal voor bedrijven die hun energiebeheer willen optimaliseren en kosten willen besparen.
                                Smith Solar helpt jouw bedrijf met deze duurzame technologie. 
                            </div>
                        </div>
                        <div className="image-container">
                            <img src={solaredgeCIBattery} alt="foto van de SolarEdge C&I batterij" className="cover overflow-box p-5"/>
                        </div>
                    </div>
                </div>
            </div>

            <div className="py-5 container-white-background">
                <div className="container mt-4 text-black">

                    <h2 className="mb-4 text-center">
                        SolarEdge C&I batterij: krachtig en efficiënt
                    </h2>

                    <p className="text-center">
                        De CSS-OD versie is een batterij die geschikt is voor buiteninstallaties. Hij heeft een laad- en ontlaadvermogen van 50 kW en een capaciteit van 102,4 kWh. Met een 0.5C rating is de batterij in slechts twee uur volledig op te laden of te ontladen. Dit maakt de SolarEdge batterij ideaal voor bedrijven die hun energiebehoefte willen balanceren en besparen op hun energiekosten.
                    </p>

                    
                </div>
            </div>

            <div className="container container-sm">
                <h3>
                    Weerbestendig en betrouwbaar
                </h3>
                <p>
                    De CSS-OD is ontworpen om bestand te zijn tegen alle weersomstandigheden en is IP54 gecertificeerd. Met een ingebouwde airconditioningsunit blijft de batterij op de juiste temperatuur, ongeacht de buitentemperatuur.
                    Dit zorgt ervoor dat de batterij onder alle omstandigheden optimaal functioneert.
                    Bovendien biedt de batterij 10 jaar garantie en gaat hij tot 6000 cycli mee, met 70% State of Health na die periode.
                </p>
                <h3>
                    Volledig volgens PGS37-1 richtlijnen
                </h3>
                <p>
                    Bij de installatie van grote batterijsystemen spelen verzekeringsmaatschappijen vaak een grote rol.
                    De SolarEdge C&I batterij voldoet aan de PGS37-1 richtlijnen, een belangrijk veiligheidsvoorschrift in Nederland voor de opslag van energie.
                    Dit betekent dat je kunt rekenen op een veilige en verzekeringsvriendelijke oplossing, die voldoet aan de strengste normen op het gebied van brandveiligheid en risicobeheer.
                </p>
            </div>
            <div className="container">
                <MidCallToAction/>
            </div>
            <div className="container container-sm">

                <h3>
                    Eenvoudige integratie met SolarEdge Monitoring
                </h3>
                <p>
                    Een groot voordeel van de SolarEdge C&I batterij is de naadloze integratie met het SolarEdge Monitoring platform via de SolarEdge ONE Controller.
                    Hierdoor kun je eenvoudig jouw energieverbruik monitoren en optimaliseren.
                    Deze integratie zorgt voor volledige controle over het energiebeheer van jouw bedrijf.
                </p>

                <h3>
                    Maatwerk en de onbalansmarkt
                </h3>
                <p>
                    Wij bieden maatwerk voor de SolarEdge C&I batterij, zodat hij volledig kan worden afgestemd op de energiebehoeften van jouw bedrijf.
                    Daarnaast maakt de batterij het mogelijk om te handelen op de onbalansmarkt, wat bedrijven de kans geeft om te profiteren van slimme energiehandel en extra inkomsten te genereren.
                </p>

                <h3>
                    Een duurzame en toekomstgerichte oplossing
                </h3>
                <p>
                    Met de SolarEdge C&I batterij investeer je in een duurzame oplossing die niet alleen je energiekosten verlaagt, maar ook een belangrijke bijdrage levert aan de energietransitie.
                    Deze batterij maakt jouw bedrijf klaar voor een toekomst waarin efficiënt energiebeheer centraal staat. 
                </p>

                <h3>
                    Offerte aanvragen en contact opnemen
                </h3>
                <p>
                    Wil je meer weten over de mogelijkheden van de SolarEdge C&I batterij? <Link to="/offerte/">Vraag een offerte aan </Link> of <Link to="/contact/">neem contact met ons op</Link>.
                    Ons team van experts staat klaar om je te adviseren over de beste oplossing voor jouw energieopslag.
                </p>

            </div>

            <CallToAction/>

        </React.Fragment>
    )
}

export default React.memo(SolarEdgeCIBatterij);
